module.exports = __webpack_public_path__ + "media/RachelPlatten-LoneRanger.d496fcb1.mp3";